'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/online-logit-review-tooltip-template.html'));
var sliderToLogitScale = require('../factories/calibration-slider-logit-scale.json');
var OnlineLogitCalibrationChartController = function OnlineLogitCalibrationChartController($scope, $rootScope, $filter, momentService, calibrationAnalysisConstants, dataRetrieverConstants, logitSharesDataTransformationService, logitSharesNormalizationService, userSecureService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var elapsedTimeLogitKeys = ['modelElapsedTimeLogit', 'userElapsedTimeLogit'];
  var fareLogitKeys = ['modelRelativeFareLogit', 'userRelativeFareLogit'];
  $scope.chartLabel = _.get(calibrationAnalysisConstants.CHART_LABEL, $scope.chartType);
  $scope.debounceSetting = {
    debounce: 500
  };
  $scope.sliderRange = calibrationAnalysisConstants.SLIDER_SET_UP;
  $scope.slider = {
    value: 0
  };
  $scope.logitShares = [];
  $scope.applicableServices = getServicesForRtpBucket();
  $scope.scheduledServices = getServicesForReviewDateRange();
  $scope.hasCreationPermission = userSecureService.hasAuthorization('calibration-analysis', 'write');
  $scope.isClearAdjustmentsLinkVisible = function () {
    if (!$scope.hasCreationPermission) {
      return false;
    }
    var chartReviewData = $scope.chartReviewData;
    if (isTravelTimeChart()) {
      return !_.isNull(chartReviewData.originalUserElapsedTimeLogit);
    } else if (isFareChart()) {
      return !_.isNull(chartReviewData.originalUserFareLogit);
    }
    var userAdjustedTod = _.find(chartReviewData.logitTimeOfDayPreferences, function (todPref) {
      return !_.isNull(todPref.userTimeOfDayPreferenceCoefficient);
    });
    return !_.isUndefined(userAdjustedTod);
  };
  $scope.setLoadStateSliderValue = function () {
    if (isTimeOfDayChart()) {
      return;
    }
    var chartReviewData = $scope.chartReviewData;
    var userLogit = isTravelTimeChart() ? chartReviewData.userElapsedTimeLogit : chartReviewData.userRelativeFareLogit;
    $scope.setSliderValue(userLogit);
  };
  $scope.setSliderValue = function (logitValue) {
    if (_.isUndefined(logitValue)) {
      $scope.slider.value = 0;
      return;
    }
    var definedLogit = _.find(sliderToLogitScale, {
      logitValue: logitValue
    });
    if (!_.isUndefined(definedLogit)) {
      $scope.slider.value = definedLogit.sliderStep;
      return;
    }
    var closestLogit = findClosestLogitValue(logitValue, sliderToLogitScale);
    if (!_.isEmpty(closestLogit)) {
      $scope.slider.value = closestLogit.sliderStep;
      return;
    }
    $scope.slider.value = 0;
  };
  $scope.resetSlider = function () {
    $scope.slider.value = 0;
  };
  $scope.validateAndNormalizeShares = function (event) {
    if (event.which === 13) {
      $scope.normalizeShares();
    }
  };
  $scope.normalizeShares = function () {
    var logitValue;
    var overrides = {};
    var chartReviewData = $scope.chartReviewData;
    logitValue = _.get(_.find(sliderToLogitScale, {
      sliderStep: $scope.slider.value
    }), 'logitValue');
    if (!isTimeOfDayChart()) {
      var logitKeys = isTravelTimeChart() ? elapsedTimeLogitKeys : fareLogitKeys;
      _.set(chartReviewData, logitKeys[1], logitValue);
      overrides = _.pick(chartReviewData, logitKeys);
    }
    logitSharesNormalizationService.normalizeShares($scope.logitShares, $scope.chartType, logitValue);
    computeChartData();
    var overridesData = _.isEmpty(overrides) ? $scope.logitShares : overrides;
    sendUpdateRequestToGrid(overridesData, true);
    $scope.$emit('online-logit-calibration:updated-logit-shares', _.join([$scope.contextData.key, $scope.chartType], '.'));
  };
  $scope.resetLogitShares = function () {
    var overrides = {};
    var chartReviewData = $scope.chartReviewData;
    if (!isTimeOfDayChart()) {
      var logitValueKeys = isTravelTimeChart() ? elapsedTimeLogitKeys : fareLogitKeys;
      var orignalLogitValue = isTravelTimeChart() ? chartReviewData.originalUserElapsedTimeLogit : chartReviewData.originalUserFareLogit;
      _.set(chartReviewData, logitValueKeys[1], orignalLogitValue);
      overrides = _.pick(chartReviewData, logitValueKeys);
      $scope.initLogitSharesData();
    } else {
      _.map($scope.logitShares, function (share) {
        share.normalizedShare = undefined;
        share.userShare = share.originalUserShare;
        share.effectiveShare = share.originalEffectiveShare;
        share._old = null;
      });
      computeChartData();
    }
    var overridesData = _.isEmpty(overrides) ? $scope.logitShares : overrides;
    sendUpdateRequestToGrid(overridesData, false);
    $scope.$emit('online-logit-calibration:logit-shares-reset', _.join([$scope.contextData.key, $scope.chartType], '.'));
  };
  $scope.clearUserAdjustments = function () {
    $scope.slider.value = 0;
    _.map($scope.logitShares, function (share) {
      if (_.isNil(share.normalizedShare)) {
        share.normalizedShare = 0;
      }
      if (!_.isNull(share.userShare)) {
        share._old = {
          userShare: share.userShare
        };
      }
      share.userShare = null;
      share.effectiveShare = share.modelShare;
    });
    var overrides = {};
    var chartReviewData = $scope.chartReviewData;
    if (!isTimeOfDayChart()) {
      var logitValueKeys = isTravelTimeChart() ? elapsedTimeLogitKeys : fareLogitKeys;
      _.set(chartReviewData, logitValueKeys[1], null);
      overrides = _.pick(chartReviewData, logitValueKeys);
    }
    computeChartData();
    var overridesData = _.isEmpty(overrides) ? $scope.logitShares : overrides;
    sendUpdateRequestToGrid(overridesData, true);
    $scope.$emit('online-logit-calibration:updated-logit-shares', _.join([$scope.contextData.key, $scope.chartType], '.'));
  };
  $scope.handleViewTypeChange = function (viewType, oldViewType) {
    if (_.isEqual(viewType, oldViewType)) {
      return;
    }
    computeChartData();
  };
  $scope.initLogitSharesData = function () {
    var transformedLogitData = logitSharesNormalizationService.transformLogits($scope.chartReviewData, $scope.contextData, $scope.applicableServices, $scope.scheduledServices, $scope.chartType);
    $scope.logitShares = transformedLogitData.logitShares;
    if (!isTimeOfDayChart()) {
      $scope.setSliderValue(transformedLogitData.userLogit);
    }
    computeChartData();
  };
  function getViewType() {
    return _.map($scope.contextData.viewType, 'name').join('-');
  }
  $scope.updateView = function (key, prevKey) {
    if (_.isUndefined(key) || _.isEqual(key, prevKey)) {
      return;
    }
    $scope.setLoadStateSliderValue();
    $scope.applicableServices = getServicesForRtpBucket();
    $scope.scheduledServices = getServicesForReviewDateRange();
    $scope.initLogitSharesData();
  };
  $scope.syncChartAfterGridUpdate = function (event, updateKey, chartType, readingTime, updateObject) {
    if (updateKey !== $scope.chartReviewData.key || chartType !== $scope.chartType || readingTime !== $scope.chartReviewData.readingTime) {
      return;
    }
    if (isTimeOfDayChart()) {
      $scope.logitShares = updateObject;
      computeChartData();
    } else {
      var logitValueKey = isTravelTimeChart() ? elapsedTimeLogitKeys[0] : fareLogitKeys[0];
      var logitValue = _.isNull(updateObject) ? _.get($scope.chartReviewData, logitValueKey) : updateObject;
      logitSharesNormalizationService.normalizeShares($scope.logitShares, chartType, logitValue);
      computeChartData();
      $scope.setSliderValue(updateObject);
    }
  };
  function sendUpdateRequestToGrid(overridesData, highlight) {
    var attributes = _.extend($scope.contextData, _.pick($scope.chartReviewData, ['readingTime', 'rtpBucket']));
    var flattenedData = logitSharesDataTransformationService.flattenLogitShares(overridesData, attributes, $scope.chartType);
    var outBoundData = _.castArray(flattenedData);
    _.map(outBoundData, function (data) {
      setGridCustomClasses(data, highlight);
    });
    $rootScope.$broadcast('online-logit-calibration:sync-grid', outBoundData);
  }
  function setGridCustomClasses(data, highlight) {
    data.customClasses = {
      effectiveShare: highlight ? 'normalized' : undefined
    };
    var userShareStyle;
    if (highlight) {
      if (isTimeOfDayChart()) {
        if (!_.isNil(data._old)) {
          userShareStyle = 'modified';
        }
      } else {
        userShareStyle = 'modified';
      }
    }
    data.customClasses.userShare = userShareStyle;
  }
  function findClosestLogitValue(logitValue, siderLogitMapping) {
    return _.reduce(siderLogitMapping, function (processed, current) {
      if (_.isEmpty(processed)) {
        return current;
      }
      return current.logitValue <= logitValue && processed.logitValue < current.logitValue ? current : processed;
    }, {});
  }
  function getServicesForRtpBucket() {
    var rtps = $scope.chartReviewData.rtpBucket.split(' - ');
    return _.chain($scope.services).filter(function (service) {
      return service.hoursToDeparture >= _.toNumber(rtps[0]) * 24 && service.hoursToDeparture <= _.toNumber(rtps[1]) * 24;
    }).map(function (service) {
      service.departureDateMoment = momentService.of(service.departureDate, momentService.FIELD.DEPARTURE_DATE);
      service.departureTime = momentService.of(service.departureDate, momentService.FIELD.DEPARTURE_TIME);
      return service;
    }).value();
  }
  function getServicesForReviewDateRange() {
    return _.filter($scope.applicableServices, function (service) {
      return service.departureDateMoment.isSame($scope.contextData.reviewStartDate) || service.departureDateMoment.isSame($scope.contextData.reviewEndDate) || service.departureDateMoment.isBetween($scope.contextData.reviewStartDate, $scope.contextData.reviewEndDate);
    });
  }
  function computeChartData() {
    $scope.chartData = logitSharesDataTransformationService.prepareChartData($scope.logitShares, $scope.chartType, getViewType());
    $scope.renderChart($scope.chartData, $scope.chartData.length);
  }
  function isTimeOfDayChart() {
    return $scope.chartType === calibrationAnalysisConstants.CHART_TYPES.TIME_OF_DAY;
  }
  function isTravelTimeChart() {
    return $scope.chartType === calibrationAnalysisConstants.CHART_TYPES.TRAVEL_TIME;
  }
  function isFareChart() {
    return $scope.chartType === calibrationAnalysisConstants.CHART_TYPES.FARE;
  }
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d) {
      var token = d.split('-');
      if (token[0] === calibrationAnalysisConstants.BAR_DATA_TYPES.USER) {
        return '';
      }
      return rmNumberFormat(_.toNumber(token[1]), 'NUMBER');
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return '';
    },
    tooltipFormatter: function tooltipFormatter(d) {
      return tooltipTemplate({
        m1: rmNumberFormat(d.m1, 'NUMBER'),
        m2: rmNumberFormat(d.m2, 'NUMBER'),
        usr: rmNumberFormat(d.user, 'NUMBER'),
        eff: rmNumberFormat(d.eff, 'NUMBER'),
        curr: rmNumberFormat(d.curr, 'NUMBER'),
        scheduled: rmNumberFormat(d.scheduled, 'NUMBER'),
        scheduledCurr: rmNumberFormat(d.scheduledCurr, 'NUMBER'),
        m1fill: d.m1fill,
        m2fill: d.m2fill,
        efffill: d.efffill,
        model: rmNumberFormat(d.model, 'NUMBER'),
        modelfill: d.modelfill,
        type: d.type
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'rm-calibration-review-tooltip ' + $scope.chartType;
};
OnlineLogitCalibrationChartController.$inject = ['$scope', '$rootScope', '$filter', 'MomentService', 'CalibrationAnalysisConstants', 'DataRetrieverConstantsService', 'LogitSharesDataTransformationService', 'LogitSharesNormalizationService', 'UserSecureService'];
module.exports = OnlineLogitCalibrationChartController;